<template>
  <div class="catalog-form">
    <h1 id="init">
      <i class="fal fa-arrow-circle-left" @click="onCancel" title="Regresar"></i>
      <span>{{ title }}</span>

      <div class="top-tool-bar flat actions">
        <div class="action" title="Refrescar registro para obtener sus últimas actualizaciones" v-if="canRefresh" @click="loadDevice"><i class="fal fa-sync"></i> Refrescar</div>
        <div class="action" title="Eliminar registro" v-if="canDelete" @click="deleteItem"><i class="fal fa-skull"></i> Eliminar</div>
      </div>
    </h1>

    <div class="menu-area hide-md">
      <div class="list-group">
        <a href="#general" class="list-group-item list-group-item-action" aria-current="true">
          Información general
        </a>
        <a href="#history" class="list-group-item list-group-item-action" aria-current="true">
          Actualizaciones
        </a>
      </div>
    </div>

    <div class="form-area">
      <b-form v-show="!loading">
        <!-- INFORMACION GENERAL -->
        <b-card id="general" header="Información general" class="form-section">
          <div class="row">
            <div class="col-sm-12 col-md-6">
              <b-form-group
              id="input-group-name"
              label="Nombre"
              label-for="input-name">
                <b-form-input
                  id="input-name"
                  name="input-name"
                  type="text"
                  class="shadow-none"
                  v-model.trim="form.name"
                  :disabled="readOnly">
                </b-form-input>
                <small class="text-muted">ID: {{form.id}}</small>
              </b-form-group>
            </div>
            <div class="col-sm-12 col-md-6">
              <b-form-group
                id="input-group-status"
                label="Estado"
                label-for="input-status">
                <b-form-input
                  id="input-status"
                  name="input-status"
                  type="text"
                  class="shadow-none"
                  v-model.trim="statusDevice"
                  :disabled="readOnly">
                </b-form-input>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-6">
              <b-form-group
                id="input-group-uuid"
                label="UUID"
                label-for="input-uuid">
                <b-form-input
                  id="input-uuid"
                  name="input-uuid"
                  type="text"
                  class="shadow-none"
                  v-model.trim="form.uuid"
                  :disabled="readOnly">
                </b-form-input>
              </b-form-group>
            </div>
            <div class="col-sm-12 col-md-6">
              <b-form-group
              id="input-user"
              label="Usuario (Activo)"
              label-for="input-user">
                <b-form-input
                  id="input-user"
                  name="input-user"
                  type="text"
                  class="shadow-none"
                  v-model.trim="user"
                  :title="user"
                  :disabled="true">
                </b-form-input>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-6">
              <b-form-group
                id="input-group-appVersion"
                label="Versión app"
                label-for="input-appVersion">
                <b-form-input
                  id="input-appVersion"
                  name="input-appVersion"
                  type="text"
                  class="shadow-none"
                  v-model.trim="form.appVersion"
                  :disabled="readOnly">
                </b-form-input>
              </b-form-group>
            </div>
            <div class="col-sm-12 col-md-6">
              <b-form-group
              id="input-group-osVersion"
              label="Sistema operativo"
              label-for="input-osVersion">
                <b-form-input
                  id="input-osVersion"
                  name="input-osVersion"
                  type="text"
                  class="shadow-none"
                  v-model.trim="form.osVersion"
                  :disabled="readOnly">
                </b-form-input>
              </b-form-group>
            </div>
          </div>
        </b-card>

        <!-- ACTUALIZACIONES -->
        <b-card id="history" header="Actualizaciones" class="form-section" v-if="id">
          <table class="table table-responsive-md">
            <thead>
              <tr>
                <th scope="col">Evento</th>
                <th scope="col">Fecha</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Creación</td>
                <td>{{ creationDate }}</td>
              </tr>
              <tr>
                <td>Actualización</td>
                <td>{{ updateDate }}</td>
              </tr>
            </tbody>
          </table>
        </b-card>
      </b-form>

      <LoadingMask :active="loading"/>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import { Device } from '@/types/catalogs/Devices'
import LoadingMask from '@/components/generic/LoadingMask.vue'
import { MessageError } from '@/components/generic/MessageHandling.vue'
import catalogsService from '@/services/CatalogsService'
import DateFormat from '@/services/DateFormat'

@Component({
  components: {
    LoadingMask
  }
})
export default class AdminDeviceForm extends Vue {
  @Prop({ required: true, default: 0 })
  id: number

  @Prop({ required: true, default: '' })
  title: string

  @Prop({ required: false, default: false })
  readOnly: boolean

  @Prop({ required: false, default: false })
  canRefresh: boolean

  @Prop({ required: false, default: false })
  canDelete: boolean

  @Prop({ required: false, default: '' })
  user: string

  loading: boolean = false
  form: Device = Device.getInstanceForEdit()
  statusDevice = ''
  creationDate = ''
  updateDate = ''

  mounted () {
    if (this.id) {
      this.loading = true
      this.loadDevice()
    }
  }

  /**
   * GET a device by id, it query Users API
   * @param id - device
   */
  async getDevice (id: number) {
    await catalogsService.getDeviceById(id).then(data => {
      Object.assign(this.form, data)
      this.statusDevice = Device.getStatus(this.form.status)
      this.creationDate = data.creationDate ? new DateFormat(data.creationDate).toDateTimeString() : '- - / - - / - - - -'
      this.updateDate = data.updateDate ? new DateFormat(data.updateDate).toDateTimeString() : '- - / - - / - - - -'
    }).catch((error) => {
      let errorValues = {
        title: 'Error al cargar dispositivo',
        message: '',
        delay: 10000,
        error: error
      }
      new MessageError({ propsData: errorValues }).displayMessage()
    }).finally(() => {
      this.loading = false
    })
  }

  /**
   * Call getDevice with id from form
   */
  loadDevice () {
    this.getDevice(this.id)
  }

  /**
   * Emit event to remove item
   */
  deleteItem () {
    this.$emit('delete-item')
  }

  /**
   * Close form view
   */
  onCancel () {
    this.$emit('close')
  }
}
</script>
